const Box = require('components/Box');
const Flex = require('components/Flex');
const Grid = require('components/Grid');
const Text = require('components/Text');
const Link = require('components/Link');
const Image = require('components/Image/Image');
const Container = require('components/Container');
const Divider = require('components/Divider');
const Button = require('components/Button');
const Icon = require('components/Icon');

const ui = {
    Box,
    Flex,
    Grid,
    Text,
    Link,
    Image,
    Container,
    Divider,
    Button,
    Icon
};

module.exports = ui;
